export default __webpack_public_path__ + "static/media/chani headache.d91b84f3.svg";